import axios from "axios";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import constants from "@/constants";

class BookingGetters {
  static async getBookingsByStatus(trekId, status, filters, searchText) {
    try {
      return new Promise((resolve, reject) => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (user) => {
          if (user) {
            auth.currentUser
              .getIdToken(/* forceRefresh */ true)
              .then((idToken) => {
                const url = `${constants.apiUrl}/booking-getters/bookings-by-status/${trekId}?status=${status}&filters=${filters}&searchText=${searchText}`;
                const config = {
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: `Bearer ${idToken}`,
                  },
                };

                axios
                  .get(url, config)
                  .then((response) => {
                    const data = response.data;
                    unsubscribe();
                    resolve(data);
                  })
                  .catch((error) => {
                    reject(error);
                  });
              })
              .catch((err) => {
                reject(err);
              });
          } else {
            reject("user not found");
          }
        });
      });
    } catch (error) {
      return error;
    }
  }
  static async getBookingsById(bookingId) {
    try {
      return new Promise((resolve, reject) => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (user) => {
          if (user) {
            auth.currentUser
              .getIdToken(/* forceRefresh */ true)
              .then((idToken) => {
                const url = `${constants.apiUrl}/booking-getters/bookings-by-id/${bookingId}`;
                const config = {
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: `Bearer ${idToken}`,
                  },
                };

                axios
                  .get(url, config)
                  .then((response) => {
                    const data = response.data;
                    unsubscribe();
                    resolve(data);
                  })
                  .catch((error) => {
                    reject(error);
                  });
              })
              .catch((err) => {
                reject(err);
              });
          } else {
            reject("user not found");
          }
        });
      });
    } catch (error) {
      return error;
    }
  }
}

export default BookingGetters;
